import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { BiCopy } from "react-icons/bi";

function ContactMe() {
  return (
    <div className="my-5 p-3 rounded-md border border-solid shadow-md hover:border-green-300">
      <h1 className="text-4xl font-bold mb-2">Contact</h1>

      <div className="my-1">
        <h2 className="text-2xl font-semibold">이메일</h2>
        <div className="flex">
          <p className="my-1 mr-2">foflzld3387@gmail.com</p>
          <CopyToClipboard
            text="foflzld3387@gmail.com"
            onCopy={() => alert("이메일 주소가 복사되었습니다.")}
          >
            <button className="px-2 py-1 border border-solid rounded">
              <BiCopy />
            </button>
          </CopyToClipboard>
        </div>
      </div>

      {/* 이력서 다운링크 작성 예정 */}
    </div>
  );
}

export default ContactMe;
